document.addEventListener("DOMContentLoaded", function() {
  // Tìm thẻ 'a' có chứa text là "Contact" và nằm trong class menu-list__link
  const contactLink = document.querySelector('.menu-list__link[href="/pages/contact"]');
  
  if (contactLink) {
    contactLink.classList.add('menu-button');
  }
});

document.addEventListener("DOMContentLoaded", function() {
  const portalLinks = document.querySelectorAll('.menu-list__link[href*="portal.kareo.com"]');
  portalLinks.forEach(function(link) {
    link.classList.add('menu-button', 'green');
    link.setAttribute('target', '_blank');
    link.setAttribute('rel', 'noopener noreferrer');
  });
});

document.addEventListener('DOMContentLoaded', function() {
    const isDesignMode = window.Shopify && window.Shopify.designMode;
    if (isDesignMode) return;

    const megaItems = Array.from(document.querySelectorAll('.mega-nav-item'));
    const mobileContainer = document.querySelector('.mega-nav-list');
    const hamburger = document.querySelector('.va-ham');
    const overlay = document.querySelector('.mega-menu-overlay');
    const headerContainer = document.querySelector('.header-section') || document.body;

    // Thêm đoạn này vào bên trong DOMContentLoaded của bạn
    const closeInsideBtn = document.querySelector('.close-slide-btn');

    if (closeInsideBtn) {
        closeInsideBtn.addEventListener('click', function() {
            document.body.classList.remove('menu-open');
            // Nếu bạn có dùng style.display trực tiếp thì thêm dòng dưới:
            const mobileNav = document.querySelector('.mega-nav-container');
            if(mobileNav) mobileNav.style.display = 'none';
        });
    }

    const getCleanHandle = (str) => {
        if (!str) return '';
        return str.toLowerCase().trim()
            .normalize("NFD").replace(/[\u0300-\u036f]/g, "")
            .replace(/[^\w\s-]/g, '').replace(/[\s_-]+/g, '-').replace(/^-+|-+$/g, '');
    };

    const syncMenus = () => {
        const desktopNavLinks = document.querySelectorAll('.menu-list__list-item');
        
        // Desktop Sync
        desktopNavLinks.forEach(li => {
            if (li.querySelector('.mega-nav-item')) return;
            const titleEl = li.querySelector('.menu-list__link-title');
            if (!titleEl) return;

            const handle = getCleanHandle(titleEl.textContent);
            const targetMega = megaItems.find(item => item.dataset.megaHandle === handle);
            
            if (targetMega) {
                li.classList.add('has-custom-mega');
                const cloneForDesktop = targetMega.cloneNode(true);
                li.appendChild(cloneForDesktop);
            }
        });

        // Mobile Sync
        if (window.innerWidth < 1024 && mobileContainer && mobileContainer.children.length === 0) {
            megaItems.forEach(item => {
                const cloneForMobile = item.cloneNode(true);
                mobileContainer.appendChild(cloneForMobile);
            });
        }
    };

    // LOGIC ĐÓNG/MỞ SIDEBAR
    if (hamburger) {
        hamburger.addEventListener('click', function(e) {
            e.preventDefault();
            document.body.classList.toggle('menu-open');
        });
    }

    if (overlay) {
        overlay.addEventListener('click', () => {
            document.body.classList.remove('menu-open');
        });
    }

    // --- CẬP NHẬT: XỬ LÝ ACCORDION ĐA TẦNG ---
    document.addEventListener('click', function(e) {
        if (window.innerWidth >= 1024) return;

        // 1. Click Tầng 1 (Menu Chính: Comprehensive Medical Care,...)
        const tier1Toggle = e.target.closest('.mega-menu-toggle-icon'); 
        // Nếu bạn muốn click vào cả dòng chữ để mở thì dùng: e.target.closest('.mega-menu-mobile-header')
        
        if (tier1Toggle) {
            e.preventDefault();
            const parentItem = tier1Toggle.closest('.mega-nav-item');
            parentItem.classList.toggle('is-open'); // Class này điều khiển hiện .mega-dropdown
        }

        // 2. Click Tầng 2 (Các cột: Surgical Services,...)
        const tier2Header = e.target.closest('.mega-col-header');
        if (tier2Header) {
            // Kiểm tra nếu click vào icon mũi tên hoặc tiêu đề
            const parentCol = tier2Header.closest('.mega-col');
            if (parentCol) {
                // e.preventDefault(); // Mở ra nếu bạn muốn vô hiệu hóa link của Col Title trên mobile
                parentCol.classList.toggle('is-active');
            }
        }
    });

    syncMenus();
    window.addEventListener('resize', syncMenus);

    // Observer để handle Ajax/Theme re-render
    const observer = new MutationObserver((mutations) => {
        if (mutations.some(m => m.type === 'childList')) {
            requestAnimationFrame(syncMenus);
        }
    });

    observer.observe(headerContainer, { childList: true, subtree: true });
});